/**
 * Sprunglink „Zum Inhalt springen“ (Hello, header.php → #pa-content).
 *
 * Der Anker steht direkt nach dem fixen Header ganz oben – der Sprung wäre unsichtbar. Deshalb springt der Link zum ersten
 * echten Inhalt nach dem Anker: zur Hauptüberschrift (h1) oder zu einem Bedienelement davor. Das Ziel bekommt den Fokus und
 * ist markiert, bis der Fokus weiterwandert. Ohne JS bleibt der Anker.
 */
import { qs, qsa, FOCUSABLE } from '../utils/dom.js';

const MARK = 'data-pa-skip-target';

function visible(el) {
	if (!el.getClientRects().length) return false;
	if (el.closest('[hidden], [inert], [aria-hidden="true"], dialog, .pa-footer, .pa-header')) return false;
	const cs = window.getComputedStyle(el);
	return cs.visibility !== 'hidden' && cs.display !== 'none';
}

function findTarget(anchor) {
	return qsa(`h1, ${FOCUSABLE}`).find((el) =>
		(anchor.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_FOLLOWING) && visible(el)
	) || null;
}

export function init() {
	const link = qs('.skip-link');
	const anchor = qs('#pa-content');
	if (!link || !anchor) return;

	link.addEventListener('click', (e) => {
		const target = findTarget(anchor);
		if (!target) return;
		e.preventDefault();

		const added = !target.matches(FOCUSABLE) && !target.hasAttribute('tabindex');
		if (added) target.setAttribute('tabindex', '-1');
		target.setAttribute(MARK, '');
		target.addEventListener('blur', () => {
			target.removeAttribute(MARK);
			if (added) target.removeAttribute('tabindex');
		}, { once: true });

		const header = parseFloat(window.getComputedStyle(document.documentElement).getPropertyValue('--pa-header-height')) || 0;
		const top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - header - 24);
		target.focus({ preventScroll: true });
		window.scrollTo({ top });
	});
}
